/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-22 19:18:22
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import { CommonUtil } from 'src/util/commonUtil';
export declare namespace DeclareMaintenanceDOI {
    export interface RowDataI {
        auditor: string;
        cause: string;
        declare_type: number;
        id: number;
        initiator: string;
        operational_site: any;
        ops_number: string;
        sponsor_datetime: string;
        status: number;
    }

    export interface QueryRowDataParamsI extends PageDo {
        keyword?: string;
        end_time?: Integer;
        start_time?: Integer;
        status?: Integer;
        declare_type?: Integer;
    }

    export interface QueryDetailResultI {
        cause: string
        declare_type_id: number
        declare_type: string
        initiator: '余水生_超管';
        operational_site: any
        operational_time: number
        ops_number: string
        sponsor_datetime: string
        status: number;
        refuse_cause: string;
        audit_time: string
        auditor: string
    }

    export interface OperateParamsI {
        id?: Integer
        declare_type: Integer
        operational_time: Integer
        cause: string
        operational_info: any
    }
}
export default class DeclareMaintenanceApi {
    /**
     * 查询列表
     * @param {DeclareMaintenanceDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: DeclareMaintenanceDOI.QueryRowDataParamsI): Promise<ResultPageDo<DeclareMaintenanceDOI.RowDataI[]>> {
        return Api.post('/ops/declare/list/get', {
            declare_type: defaultNullValue,
            status: defaultNullValue,
            keyword: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<DeclareMaintenanceDOI.QueryDetailResultI>> {
        return Api.post('/ops/declare/particulars/get', params);
    }
    /**
     * 新增
     * @param {DeclareMaintenanceDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: DeclareMaintenanceDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/declare/add', data);
    }

    /**
     * 修改
     * @param {DeclareMaintenanceDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: DeclareMaintenanceDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/declare/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(data: { ids: Array<number> }): Promise<Result<any>> {
        return Api.post('/ops/declare/batch/delete', data);
    }

    static async searchDeclareTypeList(data: PageDo = {}): Promise<Result<any>> {
        return Api.post('/ops/declare/type/get', {
            ...data,
            page_size: 100000,
            page_index: 1,
        });
    }

    static async searchComponentsById(data: {id: number}): Promise<Result<{component_id: number, name: string}[]>> {
        if(CommonUtil.isFieldEmpty(data.id)) {
            return {
                code: 0,
                data: [],
                message: ''
            }
        } 
        return Api.post('/ops/device_id/by/component', data);
    }

    static async batchAudit(data:{ids: number[], refuse_cause: string, status:number, timestamp:Integer}): Promise<Result<any>> {
        return Api.post('/ops/declare/batch/check', data);
    }
}
